export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";